import { commaNumber, firstName } from 'utils'

export default function MemberItemCard({ data, onClick }) {
    return (
        <div
            onClick={onClick}
            className="shrink-0 grow-0 bg-dark-500 rounded-lg p-6 h-36 flex flex-col justify-center items-center text-center">
            <div className="text-secundary font-semibold">
                <span className="text-2xl mr-1">
                    {commaNumber(data.totalKilometers)}
                </span>
                <span className="text-xs">kms</span>
            </div>
            <div className="text-white font-semibold uppercase mt-2 text-[10px]">
                {firstName(data.name)} {firstName(data.lastName)}
                <div className="text-text text-xs capitalize mt-1">
                    {data.role}
                </div>
            </div>
        </div>
    )
}
